<template>
    <div class="row">
        <ss-catalog-list :items="gyms"></ss-catalog-list>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ssCatalogList from './../../components/common/ss_catalog_list.vue';

    export default {
        layout: 'default',
        name: 'CatalogIndex',

        components: {
            ssCatalogList
        },

        data: () => ({}),

        computed: {
            ...mapGetters({
                getGyms: 'getGyms'
            }),

            gyms() {
                return this.getGyms;
            }
        },

        created() {
            this.$store.dispatch('getGyms');
        },

        methods: {}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/catalog/index.vue